import React from "react";
import classes from "./avatar.module.scss";

interface AvatarProps {
    firstName: string;
    lastName?: string;
    photoFile?: string | null;
    /** Diameter in px. */
    size?: number;
}

/** The signed-in user's photo, or their initials on a slate disc. */
const Avatar: React.FC<AvatarProps> = ({ firstName, lastName, photoFile, size = 30 }) => {
    const initials = (firstName.charAt(0) + (lastName ? lastName.charAt(0) : "")).toUpperCase();
    return (
        <span className={classes.avatar} style={{ width: size, height: size, fontSize: Math.round(size * 0.4) }} aria-hidden="true">
            {photoFile ? <img src={photoFile} alt="" className={classes.photo} /> : <span className={classes.initials}>{initials}</span>}
        </span>
    );
};

export default Avatar;
